import footerComponent from './footer.component';

const footerModule = angular.module('footer', [
])
  .component('footer', footerComponent)
  .name;

export default footerModule;
